import { useState, useRef, useEffect } from "react";
import { useLocation } from "nystem-components";

const toType = {
  int: (val) => (val !== "" ? parseInt(val || 0, 10) : undefined),
  float: (val) => (val !== "" ? parseFloat(val || 0) : undefined),
  array: (val) => (val === "" ? undefined : val),
};

const getQueryValue = (query, type, saveId) => {
  if (!saveId) return "";
  const value = new URLSearchParams(query).get(saveId) || "";
  return type ? toType[type](value) : value;
};

const useRouterQueryStore = (saveId, type, push, reload) => {
  const location = useLocation();

  const ref = useRef();
  const { search } = location;

  const [value, setValue] = useState(getQueryValue(search, type, saveId));
  ref.current = value;

  useEffect(() => {
    if (!saveId) return;

    const newVal = getQueryValue(search, type, saveId);
    if (newVal !== ref.current) setValue(newVal);
  }, [saveId, search, type]);

  const setRouterValue = (value) => {
    setValue(value);

    if (!saveId) return;

    const query = new URLSearchParams(window.location.search);
    if (value) query.set(saveId, value.toString());
    else query.delete(saveId);
    const search = query.toString();
    window.history[push ? "pushState" : "replaceState"]({}, "", `${window.location.pathname}${search ? `?${search}` : ""}${window.location.hash}`);
  };

  return [value === "" ? undefined : value, setRouterValue];
};

export default useRouterQueryStore;
